// const SHEET_RANGE = "!C1:CU";

const API_KEY = "AIzaSyBbE1HG6YxtjTImASzryFvLtStaFsqFJTY";
const SHEET_ID = "1XlfiZ73kvKeVfboehfnDqIeAM3MlZUtfCM8H75RpoaU";

const cache = new Map();
const CACHE_DURATION = 5 * 60 * 1000;

const translateDateToEn = (uaDateString) => {
	if (!uaDateString) return "";

	// нормалізація: замінюємо різні пробіли/апострофи, прибираємо "р." і зайві пробіли
	let s = String(uaDateString)
		.replace(/\u00A0|\u202F/g, " ")            // NBSP, narrow NBSP -> normal space
		.replace(/\u2019|\u2018|\u02BC/g, "'")     // різні апострофи -> '
		.replace(/\br\.?$/i, "")                   // прибрати "р" або "р."
		.trim();

	// спробуємо розділити weekday, якщо є: "четвер, 28 серпня 2025"
	const parts = s.split(",");
	let uaDay = null;
	let rest = parts.length > 1 ? parts.slice(1).join(",").trim() : parts[0].trim();

	if (parts.length > 1) {
		uaDay = parts[0].trim().toLowerCase();
	}

	// розбираємо решту: номер дня, місяць (у відмінку), рік
	const restParts = rest.split(/\s+/);
	const dayNum = restParts[0];
	const uaMonth = (restParts[1] || "").toLowerCase();
	const year = restParts[2] || restParts[1] || "";

	const days = {
		"понеділок": "Monday",
		"вівторок": "Tuesday",
		"середа": "Wednesday",
		"четвер": "Thursday",
		"п'ятниця": "Friday",
		"пʼятниця": "Friday",
		"субота": "Saturday",
		"неділя": "Sunday",
	};

	const months = {
		"січня": "January",
		"лютого": "February",
		"березня": "March",
		"квітня": "April",
		"травня": "May",
		"червня": "June",
		"липня": "July",
		"серпня": "August",
		"вересня": "September",
		"жовтня": "October",
		"листопада": "November",
		"грудня": "December",
	};

	const enDay = uaDay ? days[uaDay] : null;
	const enMonth = months[uaMonth] || uaMonth; // якщо місяць не знайшли — віддамо як є

	return `${enDay ? enDay + ", " : ""}${dayNum} ${enMonth} ${year}`.trim();
};

const parseEventStart = (url, timeFrom) => {
	const slug = String(url || '').split('/event/')[1] || '';
	const day = slug.match(/^(\d{4})-(\d{2})-(\d{2})/);

	if (!day) {
		return null;
	}

	const [, year, month, date] = day;
	const time = String(timeFrom || '').match(/^(\d{1,2}):(\d{2})/);

	if (!time) {
		return new Date(Number(year), Number(month) - 1, Number(date), 23, 59, 59);
	}

	return new Date(Number(year), Number(month) - 1, Number(date), Number(time[1]), Number(time[2]));
};

const processSheetData = (data) => {
	return (
		data.values
			?.slice(2)
			.filter((item) => item[3]?.trim() !== "")
			.map((item) => {
				const uaDate = item[0];

				return {
					date: uaDate,
					time: `${item[1]}${item[2] !== '' ? ` - ${item[2]}` : ''}`,

					startsAt: parseEventStart(item[3], item[1]),

					url: item[3],
					form: item[4],
					image: item[5],
					limit: item[6],

					uk: {
						date: uaDate,
						form_header: item[7],
						form_title: item[8],
						form_subtitle: item[9],
						description: item[10],
						form_name: item[11],
						form_phone: item[12],
						form_comment: item[13],
						form_address: item[14],
						form_response: item[15],
					},

					en: {
						date: translateDateToEn(uaDate),
						form_header: item[16],
						form_title: item[17],
						form_subtitle: item[18],
						description: item[19],
						form_name: item[20],
						form_phone: item[21],
						form_comment: item[22],
						form_address: item[23],
						form_response: item[24],
					},
				};
			}) || []
	);
};


// Функція для перевірки чи кеш актуальний
const isCacheValid = (cacheEntry) => {
	return cacheEntry && (Date.now() - cacheEntry.timestamp) < CACHE_DURATION;
};

// Функція для отримання даних з кешу
const getCachedData = (cacheKey) => {
	const cacheEntry = cache.get(cacheKey);
	if (isCacheValid(cacheEntry)) {
		console.log(`Data loaded from cache for ${cacheKey}`);
		return cacheEntry.data;
	}
	return null;
};

// збереження в кеш
const setCachedData = (cacheKey, data) => {
	cache.set(cacheKey, {
		data,
		timestamp: Date.now()
	});
};

export async function fetchGoogleSheetData(sheet = "events") {
	const cacheKey = `${sheet}_${SHEET_ID}`;

	const cachedData = getCachedData(cacheKey);
	if (cachedData) {
		return cachedData;
	}

	const url = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/events?key=${API_KEY}`;

	const fetchData = async (fetchUrl) => {
		const response = await fetch(fetchUrl);
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}
		const data = await response.json();
		// console.log(data)
		// console.log(`Data fetched successfully with ${apiKeyType} API key.`);
		return processSheetData(data);
	};

	try {
		const data = await fetchData(url);
		// console.log(data)
		setCachedData(cacheKey, data);
		return data;
	} catch (error) {
			return [];
	}
}